import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation, Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import MERGE_SHOPPING_LISTS from '../operations/mutations/merge-shopping-lists.js';
import { useGetMyWishlistId } from './use-get-my-wishlist-id.js';

/*
  This hook is used in scenarios where a user has both an anonymous wish list (stored in localStorage)
  and then logs in to their account and also has a wish list present there. Instead of keeping two
  separate copies, we want to merge these shopping lists into one and add the local storage list
  to the list we have stored in CommerceTools.
*/ const useMergeShoppinglists = ()=>{
    const { locale  } = useIntl();
    const [hasError, setHasError] = React.useState(false);
    const { localWishlist , clearWishlist  } = useWishlistId();
    const { id: userWishlistId  } = useGetMyWishlistId();
    const localWishlistId = localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id;
    const [mutation, { loading , called  }] = useMutation(MERGE_SHOPPING_LISTS, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        refetchQueries: [
            'GetShoppingListCount',
            'GetMyWishlistId',
            'GetMyWishlist'
        ]
    });
    const mergeShoppinglists = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        try {
            if (localWishlistId && localWishlistId !== userWishlistId && !called) {
                var ref;
                const { data  } = yield mutation({
                    variables: {
                        input: {
                            auxiliaryShoppinglistId: localWishlistId,
                            shoppinglistType: Types.ShoppinglistType.WISHLIST,
                            mainShoppinglistId: userWishlistId !== null && userWishlistId !== void 0 ? userWishlistId : null
                        }
                    }
                });
                if ((ref = data === null || data === void 0 ? void 0 : data.mergeShoppinglists.shoppinglist) === null || ref === void 0 ? void 0 : ref.id) {
                    clearWishlist();
                }
                if (data === null || data === void 0 ? void 0 : data.mergeShoppinglists.failure) {
                    throw new Error(`Merging shopping lists failed: ${data.mergeShoppinglists.failure.message}`);
                }
            }
        } catch (e) {
            setHasError(true);
            console.error('Error while merging shopping lists', e);
        }
    }), [
        called,
        localWishlistId,
        userWishlistId,
        mutation,
        clearWishlist
    ]);
    return {
        loading,
        error: hasError,
        mergeShoppinglists
    };
};

export { useMergeShoppinglists };
//# sourceMappingURL=use-merge-shopping-lists.js.map
